import { Image, styled } from '@grupoboticario/flora-react'
import { Link } from 'react-router-dom'

export const CategoryImage = styled(Image, {
  minWidth: '140px',
  maxWidth: '140px',
  height: '120px',
  objectFit: 'cover',
  borderRadius: '$small',
})

export const CategoryLink = styled(Link, {
  maxWidth: '140px',
  width: '140px',
  color: '$statusInfoActionableAltContent',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '$1',
})
